import { Helmet } from 'react-helmet-async';
import { Box, Button, Typography, Paper } from '@mui/material';
import Logo from '../components/logo';
import { useUser } from '../hooks/UserContext';

export default function WaitingPage() {
  const { logout } = useUser();

  return (
    <>
      <Helmet><title>Access Pending | TERRRA</title></Helmet>
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'background.default' }}>
        <Paper elevation={4} sx={{ p: 5, maxWidth: 420, textAlign: 'center', borderRadius: 3 }}>
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
            <Logo disabledLink sx={{ width: 48, height: 48 }} />
          </Box>
          <Typography variant="h5" sx={{ mb: 2, fontWeight: 700 }}>Access Pending</Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 1 }}>
            Your account has been created.
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            An administrator will grant you access shortly. Once access is granted, log out and log back in to continue.
          </Typography>
          <Button variant="outlined" size="small" onClick={logout}>Log out</Button>
        </Paper>
      </Box>
    </>
  );
}
